import React from 'react';
import './index.css';

export const Label16 = ({ bold=false, disabled=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? '600': 'normal' };
    const cssClass = disabled ? "label16 labelDisabled" : "label16";
    return <label className={cssClass} style={textStyle}>{children}</label>;
};